import { RootQueriesContext } from "@/queriesContext/rootQueriesContext/context";
import { RootQueriesContextProvider } from "@/queriesContext/rootQueriesContext/Provider";

const rootQueriesContext = {
  useData: RootQueriesContext.useData,
  Provider: RootQueriesContextProvider,
};

export { rootQueriesContext };
